import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

export default function Link({ children, href, className, amplitude }: any) {
  if (href.startsWith('/')) {
    return (
      <GatsbyLink to={href} className={className} data-amplitude={amplitude}>
        {children}
      </GatsbyLink>
    )
  }

  const onPage = href.startsWith('#')
  return onPage ? (
    <a href={href} className={className}>
      {children}
    </a>
  ) : (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  )
}
